import {ErrorResponse, ProductDataItem} from "../types/StudioAPITypes";
import {DEFAULT_REQUEST_OPTIONS} from "../utils/constants";
import {RequestOptions} from "../types/Types";

export const FETCH_PRODUCTS_BASE = 'FETCH_PRODUCTS';
export const FETCH_PRODUCTS_BEGIN   = `${FETCH_PRODUCTS_BASE}_BEGIN`;
export const FETCH_PRODUCTS_SUCCESS = `${FETCH_PRODUCTS_BASE}_SUCCESS`;
export const FETCH_PRODUCTS_FAILURE = `${FETCH_PRODUCTS_BASE}_FAILURE`;

export const FETCH_PRODUCT_STATUS_BASE = `FETCH_PRODUCT_STATUS`;
export const FETCH_PRODUCT_STATUS_SUCCESS = `${FETCH_PRODUCT_STATUS_BASE}_SUCCESS`;
export const FETCH_PRODUCT_STATUS_FAILURE   = `${FETCH_PRODUCT_STATUS_BASE}_FAILURE`;

export const CREATE_PRODUCT_BASE = 'CREATE_PRODUCT';
export const CREATE_PRODUCT_BEGIN = `${CREATE_PRODUCT_BASE}_BEGIN`;
export const CREATE_PRODUCT_SUCCESS = `${CREATE_PRODUCT_BASE}_SUCCESS`;
export const CREATE_PRODUCT_FAILURE = `${CREATE_PRODUCT_BASE}_FAILURE`;

export const UPDATE_PRODUCT_BASE = `UPDATE_PRODUCT`;
export const UPDATE_PRODUCT_BEGIN = `${UPDATE_PRODUCT_BASE}_BEGIN`;
export const UPDATE_PRODUCT_SUCCESS = `${UPDATE_PRODUCT_BASE}_SUCCESS`;
export const UPDATE_PRODUCT_FAILURE = `${UPDATE_PRODUCT_BASE}_FAILURE`;

export const DUPLICATE_PRODUCT_BASE = `DUPLICATE_PRODUCT`;
export const DUPLICATE_PRODUCT_BEGIN = `${DUPLICATE_PRODUCT_BASE}_BEGIN`;
export const DUPLICATE_PRODUCT_SUCCESS = `${DUPLICATE_PRODUCT_BASE}_SUCCESS`;
export const DUPLICATE_PRODUCT_FAILURE = `${DUPLICATE_PRODUCT_BASE}_FAILURE`;

export const DELETE_PRODUCT_BASE = `DELETE_PRODUCT`;
export const DELETE_PRODUCT_BEGIN = `${DELETE_PRODUCT_BASE}_BEGIN`;
export const DELETE_PRODUCT_SUCCESS = `${DELETE_PRODUCT_BASE}_SUCCESS`;
export const DELETE_PRODUCT_FAILURE = `${DELETE_PRODUCT_BASE}_FAILURE`;

export const IMPORT_FILE_BASE = `IMPORT_FILE`;
export const IMPORT_FILE_BEGIN = `${IMPORT_FILE_BASE}_BEGIN`;
export const IMPORT_FILE_SUCCESS = `${IMPORT_FILE_BASE}_SUCCESS`;
export const IMPORT_FILE_FAILURE = `${IMPORT_FILE_BASE}_FAILURE`;
export const IMPORT_FILE_PROGRESS_STATUS = `${IMPORT_FILE_BASE}_PROGRESS_STATUS`;
export const IMPORT_FILE_RESET_PROCESS = `${IMPORT_FILE_BASE}_RESET_PROCESS`;

export const UPDATE_ITEM_IN_EDIT_MODE = `UPDATE_ITEM_IN_EDIT_MODE`;
export const UPDATE_PRODUCTS_FILTER = 'UPDATE_PRODUCTS_FILTER';

export const UPDATE_PRODUCTS = 'UPDATE_PRODUCTS';

export const fetchProductsBegin = (projectId: string, options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: FETCH_PRODUCTS_BEGIN,
  projectId: projectId,
  options: options
});

export const fetchProductsSuccess = (products: any) => ({
  type: FETCH_PRODUCTS_SUCCESS,
  payload: { products }
});

export const fetchProductsError = (error: ErrorResponse) => ({
  type: FETCH_PRODUCTS_FAILURE,
  payload: { error }
});

export const createProductBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: CREATE_PRODUCT_BEGIN,
  options: options
});

export const createProductSuccess = (product: any) => ({
  type: CREATE_PRODUCT_SUCCESS,
  payload: { product }
});

export const createProductFailure = (error: ErrorResponse) => ({
  type: CREATE_PRODUCT_FAILURE,
  payload: { error }
});

export const updateItemInEditMode = (productId: string) => ({
  type: UPDATE_ITEM_IN_EDIT_MODE,
  id: productId
});

export const updateProductBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: UPDATE_PRODUCT_BEGIN,
  options: options
});

export const updateProductSuccess = (product: any) => ({
  type: UPDATE_PRODUCT_SUCCESS,
  payload: { product }
});

export const updateProductFailure = (error: ErrorResponse) => ({
  type: UPDATE_PRODUCT_FAILURE,
  payload: { error }
});

export const deleteProductBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: DELETE_PRODUCT_BEGIN,
  options: options
});

export const deleteProductSuccess = (product: any) => ({
  type: DELETE_PRODUCT_SUCCESS,
  payload: { product }
});

export const deleteProductFailure = (error: ErrorResponse) => ({
  type: DELETE_PRODUCT_FAILURE,
  payload: { error }
});

export const duplicateProductBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: DUPLICATE_PRODUCT_BEGIN,
  options: options
});

export const duplicateProductSuccess = (product: any) => ({
  type: DUPLICATE_PRODUCT_SUCCESS,
  payload: { product },
});

export const duplicateProductFailure = (error: ErrorResponse) => ({
  type: DUPLICATE_PRODUCT_FAILURE,
  payload: { error }
});

export const fetchProductStatusSuccess = (productStatus: any, inProgress: boolean, progressPct: number) => ({
  type: FETCH_PRODUCT_STATUS_SUCCESS,
  payload: { productStatus},
  inProgress: inProgress,
  progressPct: progressPct
});

export const fetchProductStatusFailure = (error: ErrorResponse) => ({
  type: FETCH_PRODUCT_STATUS_FAILURE,
  payload: { error }
});

export const updateProductsFilter = (filter: string) => ({
  type: UPDATE_PRODUCTS_FILTER,
  filter: filter
});

export const importFileBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: IMPORT_FILE_BEGIN,
  options: options
});

export const importFileSuccess = (product: any) => ({
  type: IMPORT_FILE_SUCCESS,
  payload: { product }
});

export const importFileFailure = ( error: ErrorResponse) => ({
  type: IMPORT_FILE_FAILURE,
  payload: { error }
});

export const importFileProgressStatus = ( percent: number) => ({
  type: IMPORT_FILE_PROGRESS_STATUS,
  payload: { percent }
});

export const updateProducts = (items: ProductDataItem[]) => ({
  type: UPDATE_PRODUCTS,
  items: items
});

export const importFileResetProcess = () => ({
  type: IMPORT_FILE_RESET_PROCESS
});

